import service from '@/services';
import useWorkspaceStore from '@/stores/WorkspaceStore';
import { SOURCE_COLUMNS } from '@/types/filterKeyConst';

import { StructuredSourceSelector } from '../components/StructuredSourceSelector';

export const useSourceFilterMap = () => {
  const workspaceFieldOptions = useWorkspaceStore(
    (state) => state.workspaceFieldOptions,
  );

  const fieldOptions: StructuredFieldOptionMap = {
    [SOURCE_COLUMNS.SOURCE_TYPE]: {
      columnKey: SOURCE_COLUMNS.SOURCE_TYPE,
      columnName: 'Source type',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'custom',
        Component: StructuredSourceSelector,
      },
    },
    [SOURCE_COLUMNS.SOURCE_TARGET]: {
      columnKey: SOURCE_COLUMNS.SOURCE_TARGET,
      columnName: 'Source ID',
      isMultiValueField: true,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          if (!params?.searchValue) return [];
          const res = await service.feedback.searchSourceTarget(
            params.searchValue,
          );
          if (!res.source_targets) return [];
          return res.source_targets.map((source_target) => ({
            columnKey: SOURCE_COLUMNS.SOURCE_TARGET,
            filterKey: source_target,
            filterName: source_target,
            filterOptionNode: source_target,
          }));
        },
      },
    },
    [SOURCE_COLUMNS.DATA_ORIGIN]: {
      columnKey: SOURCE_COLUMNS.DATA_ORIGIN,
      columnName: 'Data Origin',
      isMultiValueField: false,
      filterItemOptions: {
        type: 'select',
        filterItemFetcher: async (params) => {
          const searchValue = params?.searchValue?.toLocaleLowerCase();
          return workspaceFieldOptions.data_origin_values
            .map((data) => ({
              columnKey: SOURCE_COLUMNS.DATA_ORIGIN,
              filterKey: data,
              filterName: data,
              filterOptionNode: data,
            }))
            .filter((item) => {
              if (!searchValue) return true;
              return item.filterName.toLocaleLowerCase().includes(searchValue);
            });
        },
      },
    },
  };
  return fieldOptions;
};
